import React, { useEffect, useCallback, useState } from 'react';
import { Box, Heading, Image, Select, Button, Text, Anchor } from 'grommet';
import useQuery from 'granite-admin/utils/useQuery';
import quiversLogo from './assets/quivers.png';
import quiversLogoHeading from './assets/quivers2.png';

const checkPlugins = process.env.REACT_APP_SHOPIFY_MIDDLEWARE_URL;
const redirectUrl = process.env.REACT_APP_REDIRECT_CHOOSE_BUSINESS;

const PluginRedirect = () => {
  const { query } = useQuery();

  const { shop } = query;
  const [checkPlugin, setCheckPlugin] = useState(false);
  const [pluginData, setPluginData] = useState({});

  const fetchData = useCallback(() => {
    const apiUrl = `${checkPlugins}check_existing_plugin?shop=test-paypal01`;

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        window.open(`${redirectUrl}${data.ref_id}/app_settings/${data.id}`, '_blank');
        setPluginData(data);
        setTimeout(() => {
          if (window.self !== window.top) {
            // checking if it is an iframe
            window.parent.location.href = `${redirectUrl}${pluginData.ref_id}/app_settings/${pluginData.id}`;
          } else {
            window.location.href = `${redirectUrl}${pluginData.ref_id}/app_settings/${pluginData.id}`;
          }
        }, 3000);
        setCheckPlugin(true);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }, [shop]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {checkPlugin ? (
        <>
          <Box background="#213957" fill align="center" justify="center">
            <Image src={quiversLogoHeading} height="180px" width="580px" />

            <Anchor
              label={
                <Box>
                  <Heading level={4}>Click here to go to your app settings.</Heading>
                </Box>
              }
              onClick={() => {
                if (window.self !== window.top) {
                  // checking if it is an iframe
                  window.parent.location.href = `${redirectUrl}${pluginData.ref_id}/app_settings/${pluginData.id}`;
                } else {
                  window.location.href = `${redirectUrl}${pluginData.ref_id}/app_settings/${pluginData.id}`;
                }
              }}
            />
          </Box>
        </>
      ) : (
        <Box
          background="#213957"
          fill
          align="center"
          justify="center"
          animation={{
            type: 'fadeIn',
            delay: 0,
            duration: 3000,
          }}
        >
          <Image src={quiversLogo} height="80px" width="80px" />
          <Heading level={4}>Please wait...</Heading>
        </Box>
      )}
    </>
  );
};

export default PluginRedirect;
